<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-dept-multi type="search" label="취급부서" name="deptCd" :isFirstValue="false" v-model="searchParam.deptList" />
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="hazard"
          title="부서별 유해인자 목록"
          tableId="guideBook"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          rowKey="hazardCd"
          :columnSetting="false"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <!-- <c-btn v-if="editable" label="신규" icon="add" @btnClicked="openPopup" /> -->
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'dept-harmful-factors',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '부서',
            align: 'center',
            type: "link",
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'hazardNames',
            field: 'hazardNames',
            label: '관련 유해인자',
            align: 'left',
            style: 'width:600px',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: '',
        deptList: [],
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      workFlagItems: [
        { code: 'Y', codeName: '관련' },
        { code: 'N', codeName: '미관련' },
      ],
      occSecItems: [],
      period: [ '', ''],
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.sai.hazard.list.dept.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.openPopup(row);
    },
    datachange() {
      this.setSecondItems(this.searchParam.hazardClassFstCd);
    },
    setSecondItems(hazardClassFstCd) {
      if (hazardClassFstCd){
        this.$http.url = this.$format(selectConfig.sys.code.mst.list.attr.url, 'HAZARD_CLASS_SEC_CD', hazardClassFstCd);
      } else {
        this.$http.url = this.$format(selectConfig.sys.code.mst.list.attr.url, 'HAZARD_CLASS_SEC_CD');
      }
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.occSecItems = [];
        this.searchParam.hazardClassSecCd = null;
        this.$_.forEach(_result.data, _item => {
          this.occSecItems.push({
            code: _item.code,
            codeName: _item.codeName,
          })
        })
      },);
    },
    openPopup(result) {
      this.popupOptions.target = () => import(`${"./deptHarmfulFactorsDetail.vue"}`);
      this.popupOptions.title = result.deptName + '의 유해인자 상세';
      this.popupOptions.param = {
        deptCd: result ? result.deptCd : '',
      };
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
